import { h } from 'preact'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import './styles.scss'

const ArrowDownIcon = ({ isTop, width = 16, height = 16, color }) => {
  const classNames = classnames(
    {
      top: isTop,
    },
    'arrow-down-icon'
  )

  return (
    <i>
      <svg
        className={classNames}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <path
            d="m9.602 8-4.795 4.795a.706.706 0 1 0 .998.998L11.099 8.5a.706.706 0 0 0 0-.998L5.805 2.207a.706.706 0 1 0-.998.998L9.602 8z"
            id="arrow-down-icon-a"
          />
          <path id="arrow-down-icon-c" d="M0 0h16v16H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="arrow-down-icon-b" fill="#fff">
            <use xlinkHref="#arrow-down-icon-a" />
          </mask>
          <g mask="url(#arrow-down-icon-b)">
            <use fill="#219ED9" xlinkHref="#arrow-down-icon-c" />
            <use fill={color || '#376af6'} xlinkHref="#arrow-down-icon-c" />
          </g>
        </g>
      </svg>
    </i>
  )
}

ArrowDownIcon.propTypes = {
  isTop: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default ArrowDownIcon
